import { render, staticRenderFns } from "./EditConsent.vue?vue&type=template&id=a60960e2&scoped=true&"
import script from "./EditConsent.vue?vue&type=script&lang=js&"
export * from "./EditConsent.vue?vue&type=script&lang=js&"
import style0 from "./EditConsent.vue?vue&type=style&index=0&id=a60960e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60960e2",
  null
  
)

export default component.exports